<template>
  <div class="sidebar-config__item">
    <div class="sidebar-config-empty">
      <p>{{ $t('configurationsEmpty') }}</p>
      <p>{{ $t('configureEncouragementNotice') }}</p>
      <div class="content-btn">
        <router-link
          class="btn-main btn-main--white"
          v-if="showStartButton"
          :to="{name:'configurator', query:{type: 'full'}}"
        >
          {{ $t('startConfiguration') }}
        </router-link>
        <button
          type="button"
          class="btn-main modal-trigger"
          data-modal="modal-valuation"
          v-if="showOrderQuote"
        >
          {{ $t('orderQuote') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SidebarEmpty',
    props: {
      showStartButton: Boolean,
      showOrderQuote: Boolean,
    },
  };
</script>
